const getRouterKey = userDetails => (userDetails.pmiplatform ? 'pmiRoutes' : 'rcRoutes');

/**
 * A module route may declare `feature: '<Feature name>'` to opt into a per-program
 * feature toggle. Routes that declare none are unaffected and always pass, so this
 * is safe to apply to every route descriptor.
 *
 * Matches on the feature `name` (the stable key used by the DB and by the other
 * enabledFeatures consumers), not `displayName`, which is a display label and can
 * differ from the name for the same row.
 */
export const isRouteFeatureEnabled = (router, currentActiveProgram) => {
  const requiredFeature = router && router.feature;
  if (!requiredFeature) {
    return true;
  }
  const enabledFeatures = (currentActiveProgram && currentActiveProgram.enabledFeatures) || [];
  return enabledFeatures.some(f => f.enabled === true && f.name === requiredFeature);
};

/**
 * True for a program flagged `vibrentUser` whose logged-in user's email is on the
 * internal vibrenthealth.com domain. Same condition as userActions#addFeatureTogglePermissions,
 * but evaluated live from props on every render instead of baked into permissions once at
 * login, so a route gated on it reacts to a program switch without requiring a re-login.
 */
export const isInternalVibrentUser = (currentActiveProgram, userDetail) => !!(
  currentActiveProgram && currentActiveProgram.vibrentUser &&
  userDetail && /^[A-Za-z0-9._%+-]+@vibrenthealth.com$/i.test(userDetail.username)
);

/**
 * A module route may declare `requiresInternalVibrentUser: true` to additionally restrict
 * it to internal vibrenthealth.com users on a vibrentUser program, on top of whatever
 * backend permission already gates it. Routes that declare none are unaffected.
 */
export const isRouteVisibleToUser = (router, currentActiveProgram, userDetail) => {
  if (!router || !router.requiresInternalVibrentUser) {
    return true;
  }
  return isInternalVibrentUser(currentActiveProgram, userDetail);
};

export default getRouterKey;
